import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import { useAssetSettings } from 'src/hooks/useUserSettings';

const FeatureContext = createContext(null);

export function FeatureProvider({ featureIdentifier, children, fallback = null }) {
  const { hasFeatureAccess } = useAssetSettings();
  return featureIdentifier === true || hasFeatureAccess(featureIdentifier) ? (
    <FeatureContext.Provider
      value={featureIdentifier}
    >
      {children}
    </FeatureContext.Provider>
  ) : fallback;
}

FeatureProvider.propTypes = {
  children: PropTypes.node,
  featureIdentifier: PropTypes.string.isRequired,
  fallback: PropTypes.node,
};

export default FeatureContext;